// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__0h1kQ","star":"styles_star___zXof","overlay":"styles_overlay__jRwMS"};